import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { OperationType } from "common/constants/sm-constants";
import { MentorFeedbackModel } from "common/models/page-models/mentor-feedback/mentor-feedback-data-model";
import { RouteEnvelope, WidgetModel } from "common/models/utility-models/base-model";
import { FormResolverService } from "common/resolvers/core-resolvers/form-resolver";
import { SystemService } from "common/services/core-services/system.service";
import { MentorFeedbackWidgetService } from "common/widget/mentor-feedback/mentor-feedback-widget.service";
@Injectable({
    providedIn: 'root'
})
export class MentorFeedbackResolver extends FormResolverService<MentorFeedbackModel> {
    constructor(protected ws: MentorFeedbackWidgetService, protected override router: Router, protected ss: SystemService) {
        super(ws, router, ss);
    }

    // override manageState() {
   
    //     // console.log(this.aRoute.queryParams);
    //     const envelope = new RouteEnvelope();
    //     envelope.type = OperationType.VIEW;
    
        
    //     // envelope.transferData.transferData = this.getQueryParam();
    //     return envelope;
    //   }

  override  resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
      ): Promise<any> {
        let routeMessage;
        return new Promise((resolve, reject) => {
          Promise.resolve()
            .then(() => {
              return Promise.resolve(this.getResolverMessage());
            })
            .then((message) => {
              routeMessage = message;
              if (route.queryParams['code']) {
                message.transferData.transferData = route.queryParams['code'];
              }
    
              return this.getDataBaseOnMessage(message);
            })
            .then((res) => {
              let dataRes;
              dataRes = res;
              const meta = this.getMetaForComponent();
              const widget = this.initWidget(
                routeMessage.type,
                routeMessage.transferData,
                dataRes,
                meta
              );
              return this.prepareResolveData(dataRes, meta, widget);
            })
            .then((finalRes) => {
              resolve(finalRes);
            })
            .catch((err) => {
              reject(err);
            });
        });
      }

    override manageState() {
   
        // console.log(this.aRoute.queryParams);
        const envelope = new RouteEnvelope();
        envelope.type = OperationType.UPDATE;
        //    console.log(this.aRoute)
    
        envelope.transferData = new WidgetModel();
        
        // envelope.transferData.transferData = this.getQueryParam();
        return envelope;
      }

      override modifyResponseData(dataModel: any, meta: any, widget: any) {
        const previewModel = new MentorFeedbackModel();
        // console.log(widget.transferData.transferData.student_id);
        // console.log(dataModel);

        dataModel.questions.forEach((question) => {
            //console.log(question);
            previewModel[question.id] = '';
        });
        return previewModel;
    }
}
